import { createField } from '@/components/forms/field.schema';
import { Calendar, File as FileIcon, FileText, Type } from 'lucide-react';
import { z } from 'zod';

/**
 * Fields used to drive the docs catalog filter token bar.
 *
 * Note that DocsNode is a discriminated union (group | file). The token bar
 * UI is generated from these field definitions, but the matching predicate
 * is bespoke (see docs.tree-view.tsx): file-only tokens (has_file,
 * file_type) are evaluated against files only; group visibility is derived
 * from descendants. The `name` token (free-text) matches both groups and
 * files. The fields are therefore not meant to be passed to
 * useFilterableTable directly — only `fieldsToTokenDefinitions` is reused.
 */
export const docsFields = {
  name: createField(z.string(), {
    fieldType: 'text',
    label: 'Name',
    icon: FileText,
  }),
  has_file: createField(z.boolean(), {
    fieldType: 'boolean',
    label: 'Has file',
    icon: FileIcon,
  }),
  file_type: createField(z.string(), {
    fieldType: 'select',
    label: 'Type',
    icon: Type,
    // Options are filled in at runtime from the catalog's actual extensions.
    options: [],
  }),
  date: createField(z.string(), {
    fieldType: 'date',
    label: 'Date',
    icon: Calendar,
  }),
};

export type DocsFieldKey = keyof typeof docsFields;
